var map = {
	"./avax-pairs/COM-AVAX.png": 1043,
	"./avax-pairs/DAI-AVAX.png": 1044,
	"./avax-pairs/ETH-AVAX.png": 1045,
	"./avax-pairs/ETH-AVAX.svg": 1046,
	"./avax-pairs/LINK-AVAX.svg": 1047,
	"./avax-pairs/LYD-AVAX.png": 1048,
	"./avax-pairs/OLIVE-AVAX.png": 1049,
	"./avax-pairs/OLIVE-USDT.png": 1050,
	"./avax-pairs/PNG-AVAX.png": 1051,
	"./avax-pairs/PNG-AVAX.svg": 1052,
	"./avax-pairs/SNOB-AVAX.svg": 1053,
	"./avax-pairs/SNOB3P.png": 1054,
	"./avax-pairs/SUSHI-AVAX.svg": 1055,
	"./avax-pairs/UNI-AVAX.svg": 1056,
	"./avax-pairs/USDT-AVAX.png": 1057,
	"./avax-pairs/USDT-AVAX.svg": 1058,
	"./avax-pairs/USDT-PNG.svg": 1059,
	"./avax-pairs/WBTC-AVAX.svg": 1060,
	"./avax-pairs/ZETH.svg": 1061,
	"./binance-wallet.png": 1062,
	"./bnb-pairs/AAVE-BNB.svg": 1063,
	"./bnb-pairs/ADA-BNB.svg": 1064,
	"./bnb-pairs/ALICE-BNB.svg": 1065,
	"./bnb-pairs/ALPA-BNB.svg": 1066,
	"./bnb-pairs/ALPACA-BNB.png": 1067,
	"./bnb-pairs/ALPHA-BNB.svg": 1068,
	"./bnb-pairs/APYS-BNB.svg": 1069,
	"./bnb-pairs/ARPA-BNB.svg": 1070,
	"./bnb-pairs/ASR-BNB.svg": 1071,
	"./bnb-pairs/ATA-BNB.svg": 1072,
	"./bnb-pairs/ATM-BNB.svg": 1073,
	"./bnb-pairs/ATOM-BNB.svg": 1074,
	"./bnb-pairs/AUTO-BNB.png": 1075,
	"./bnb-pairs/AVAX-BNB.svg": 1076,
	"./bnb-pairs/AXS-BNB.png": 1077,
	"./bnb-pairs/BAKE-BNB.png": 1078,
	"./bnb-pairs/BALBT-BNB.svg": 1079,
	"./bnb-pairs/BAND-BNB.svg": 1080,
	"./bnb-pairs/BAT-BNB.svg": 1081,
	"./bnb-pairs/BCH-BNB.svg": 1082,
	"./bnb-pairs/BDO-BNB.svg": 1083,
	"./bnb-pairs/BEL-BNB.svg": 1084,
	"./bnb-pairs/BELT-BNB-BELT.png": 1085,
	"./bnb-pairs/BELT-BNB.svg": 1086,
	"./bnb-pairs/BFI-BNB.svg": 1087,
	"./bnb-pairs/BHC-BNB.png": 1088,
	"./bnb-pairs/BIFI-BNB.png": 1089,
	"./bnb-pairs/BIFI-BNB.svg": 1090,
	"./bnb-pairs/BITI-BNB.png": 1091,
	"./bnb-pairs/BLIQ-BNB.png": 1092,
	"./bnb-pairs/BLK-BNB.svg": 1093,
	"./bnb-pairs/BLZ-BNB.svg": 1094,
	"./bnb-pairs/BMXX-BNB.svg": 1095,
	"./bnb-pairs/BONDLY-BNB.svg": 1096,
	"./bnb-pairs/BOPEN-BNB.svg": 1097,
	"./bnb-pairs/BOR-BNB.svg": 1098,
	"./bnb-pairs/BRY-BNB.svg": 1099,
	"./bnb-pairs/BSCX-BNB.svg": 1100,
	"./bnb-pairs/BTC-BNB.png": 1101,
	"./bnb-pairs/BTCB-BNB.svg": 1102,
	"./bnb-pairs/BTCST-BNB.svg": 1103,
	"./bnb-pairs/BTT-BNB.svg": 1104,
	"./bnb-pairs/BUNNY-BNB.svg": 1105,
	"./bnb-pairs/BUSD-BNB.png": 1106,
	"./bnb-pairs/BUSD-BNB.svg": 1107,
	"./bnb-pairs/BUX-BNB.svg": 1108,
	"./bnb-pairs/BXBTC-BNB.svg": 1109,
	"./bnb-pairs/CAKE-BNB.svg": 1110,
	"./bnb-pairs/CELR-BNB.svg": 1111,
	"./bnb-pairs/CGG-BNB.svg": 1112,
	"./bnb-pairs/COM-BNB.png": 1113,
	"./bnb-pairs/COMP-BNB.svg": 1114,
	"./bnb-pairs/COS-BNB.svg": 1115,
	"./bnb-pairs/COTI-BNB.svg": 1116,
	"./bnb-pairs/CRED-BNB.png": 1117,
	"./bnb-pairs/CTK-BNB.svg": 1118,
	"./bnb-pairs/CYC-BNB.svg": 1119,
	"./bnb-pairs/DAI-BNB.svg": 1120,
	"./bnb-pairs/DEGO-BNB.svg": 1121,
	"./bnb-pairs/DFT-BNB.svg": 1122,
	"./bnb-pairs/DITTO-BNB.svg": 1123,
	"./bnb-pairs/DODO-BNB.svg": 1124,
	"./bnb-pairs/DOGE-BNB-PCS.svg": 1125,
	"./bnb-pairs/DOGE-BNB.svg": 1126,
	"./bnb-pairs/DOT-BNB.svg": 1127,
	"./bnb-pairs/DRUGS-BNB.png": 1128,
	"./bnb-pairs/DUSK-BNB.svg": 1129,
	"./bnb-pairs/EASY-BNB.svg": 1130,
	"./bnb-pairs/EGLD-BNB.svg": 1131,
	"./bnb-pairs/EOS-BNB.svg": 1132,
	"./bnb-pairs/EPS-BNB.svg": 1133,
	"./bnb-pairs/ETC-BNB.svg": 1134,
	"./bnb-pairs/ETH-BNB.svg": 1135,
	"./bnb-pairs/EZ-BNB.svg": 1136,
	"./bnb-pairs/FIL-BNB.svg": 1137,
	"./bnb-pairs/FINE-BNB.svg": 1138,
	"./bnb-pairs/FRONT-BNB.svg": 1139,
	"./bnb-pairs/FTM-BNB.svg": 1140,
	"./bnb-pairs/FTS-BNB.svg": 1141,
	"./bnb-pairs/FUEL-BNB.png": 1142,
	"./bnb-pairs/GOLD-BNB.png": 1143,
	"./bnb-pairs/GUM-BNB.svg": 1144,
	"./bnb-pairs/GUNS-BNB.png": 1145,
	"./bnb-pairs/HARD-BNB.svg": 1146,
	"./bnb-pairs/HELMET-BNB.svg": 1147,
	"./bnb-pairs/HGET-BNB.svg": 1148,
	"./bnb-pairs/HYFI-BNB.svg": 1149,
	"./bnb-pairs/HZN-BNB.svg": 1150,
	"./bnb-pairs/INJ-BNB.svg": 1151,
	"./bnb-pairs/IOTA-BNB.svg": 1152,
	"./bnb-pairs/ITAM-BNB.svg": 1153,
	"./bnb-pairs/JBTCB-BNB.svg": 1154,
	"./bnb-pairs/JDOT-BNB.svg": 1155,
	"./bnb-pairs/JGN-BNB.png": 1156,
	"./bnb-pairs/JGN-BNB.svg": 1157,
	"./bnb-pairs/JTWT-BNB.svg": 1158,
	"./bnb-pairs/JULD-BNB.svg": 1159,
	"./bnb-pairs/JUNI-BNB.svg": 1160,
	"./bnb-pairs/JUV-BNB.svg": 1161,
	"./bnb-pairs/JXVS-BNB.svg": 1162,
	"./bnb-pairs/KALM-BNB.svg": 1163,
	"./bnb-pairs/KEBAB-BNB.png": 1164,
	"./bnb-pairs/KEYFI-BNB.svg": 1165,
	"./bnb-pairs/KTN-BNB.svg": 1166,
	"./bnb-pairs/LIEN-BNB.svg": 1167,
	"./bnb-pairs/LINK-BNB.svg": 1168,
	"./bnb-pairs/LIT-BNB.svg": 1169,
	"./bnb-pairs/LMT-BNB.svg": 1170,
	"./bnb-pairs/LTC-BNB.svg": 1171,
	"./bnb-pairs/LTO-BNB.svg": 1172,
	"./bnb-pairs/MATIC-BNB.svg": 1173,
	"./bnb-pairs/MDX-BNB.png": 1174,
	"./bnb-pairs/NAR-BNB.png": 1175,
	"./bnb-pairs/NAUT-BNB.svg": 1176,
	"./bnb-pairs/NEAR-BNB.svg": 1177,
	"./bnb-pairs/NRV-BNB.svg": 1178,
	"./bnb-pairs/ODDZ-BNB.svg": 1179,
	"./bnb-pairs/OG-BNB.svg": 1180,
	"./bnb-pairs/ONT-BNB.svg": 1181,
	"./bnb-pairs/PBTC-BNB.svg": 1182,
	"./bnb-pairs/PERL-BNB.svg": 1183,
	"./bnb-pairs/POPEN-BNB.svg": 1184,
	"./bnb-pairs/PSG-BNB.svg": 1185,
	"./bnb-pairs/REEF-BNB.svg": 1186,
	"./bnb-pairs/SFP-BNB.svg": 1187,
	"./bnb-pairs/SHIB-BNB.svg": 1188,
	"./bnb-pairs/SKILL-BNB.png": 1189,
	"./bnb-pairs/SNX-BNB.svg": 1190,
	"./bnb-pairs/SOAK-BNB.svg": 1191,
	"./bnb-pairs/SPG-BNB.svg": 1192,
	"./bnb-pairs/STEAM-BNB.svg": 1193,
	"./bnb-pairs/SUTER-BNB.svg": 1194,
	"./bnb-pairs/SWAMP-BNB.svg": 1195,
	"./bnb-pairs/SWGB-BNB.svg": 1196,
	"./bnb-pairs/SWINGBY-BNB.svg": 1197,
	"./bnb-pairs/SWIRL-BNB.png": 1198,
	"./bnb-pairs/SWTH-BNB.svg": 1199,
	"./bnb-pairs/SXP-BNB.svg": 1200,
	"./bnb-pairs/TDOGE-BNB.svg": 1201,
	"./bnb-pairs/TEN-BNB.svg": 1202,
	"./bnb-pairs/THUGS-BNB.png": 1203,
	"./bnb-pairs/TKO-BNB.svg": 1204,
	"./bnb-pairs/TLM-BNB.svg": 1205,
	"./bnb-pairs/TRADE-BNB.svg": 1206,
	"./bnb-pairs/TRX-BNB.svg": 1207,
	"./bnb-pairs/TWT-BNB.svg": 1208,
	"./bnb-pairs/TYPH-BNB.png": 1209,
	"./bnb-pairs/UNFI-BNB.svg": 1210,
	"./bnb-pairs/UNI-BNB.svg": 1211,
	"./bnb-pairs/USDC-BNB.svg": 1212,
	"./bnb-pairs/USDT-BNB.svg": 1213,
	"./bnb-pairs/VAPOR-BNB.png": 1214,
	"./bnb-pairs/VIDT-BNB.svg": 1215,
	"./bnb-pairs/VRT-BNB.svg": 1216,
	"./bnb-pairs/WATCH-BNB-APE.svg": 1217,
	"./bnb-pairs/WATCH-BNB.svg": 1218,
	"./bnb-pairs/WIN-BNB.svg": 1219,
	"./bnb-pairs/WSOTE-BNB.svg": 1220,
	"./bnb-pairs/XED-BNB.svg": 1221,
	"./bnb-pairs/XEND-BNB.svg": 1222,
	"./bnb-pairs/XRP-BNB.svg": 1223,
	"./bnb-pairs/XTZ-BNB.svg": 1224,
	"./bnb-pairs/XVS-BNB.svg": 1225,
	"./bnb-pairs/YFI-BNB.svg": 1226,
	"./bnb-pairs/YFII-BNB.svg": 1227,
	"./bnb-pairs/ZEC-BNB.svg": 1228,
	"./bnb-pairs/ZEE-BNB.svg": 1229,
	"./bnb-pairs/ZIL-BNB.svg": 1230,
	"./bnb-pairs/bROOBEE-BNB.svg": 1231,
	"./bnb-pairs/bTRI-BNB.png": 1232,
	"./bnb-pairs/pCWS-BNB.svg": 1233,
	"./busd-pairs/ALPACA-BUSD.svg": 1234,
	"./busd-pairs/BAKE-BUSD.png": 1235,
	"./busd-pairs/BCFX-BUSD.svg": 1236,
	"./busd-pairs/BIFI-BUSD.png": 1237,
	"./busd-pairs/BTCB-BUSD.svg": 1238,
	"./busd-pairs/BTR-BUSD.svg": 1239,
	"./busd-pairs/BTT-BUSD.png": 1240,
	"./busd-pairs/BUSD-USDC.svg": 1241,
	"./busd-pairs/DAI-BUSD.svg": 1242,
	"./busd-pairs/DEXE-BUSD.svg": 1243,
	"./busd-pairs/DFD-BUSD.svg": 1244,
	"./busd-pairs/FOR-BUSD.svg": 1245,
	"./busd-pairs/HAKKA-BUSD.svg": 1246,
	"./busd-pairs/HOO-BUSD.svg": 1247,
	"./busd-pairs/IOTX-BUSD.svg": 1248,
	"./busd-pairs/KEBAB-BUSD.png": 1249,
	"./busd-pairs/KUN-BUSD.svg": 1250,
	"./busd-pairs/LINA-BUSD.svg": 1251,
	"./busd-pairs/MATH-BUSD.svg": 1252,
	"./busd-pairs/MDX-BUSD.png": 1253,
	"./busd-pairs/MTRG-BUSD.svg": 1254,
	"./busd-pairs/MX-BUSD.svg": 1255,
	"./busd-pairs/NULS-BUSD.svg": 1256,
	"./busd-pairs/OIN-BUSD.svg": 1257,
	"./busd-pairs/ONE-BUSD.svg": 1258,
	"./busd-pairs/PMON-BUSD.svg": 1259,
	"./busd-pairs/QKC-BUSD.svg": 1260,
	"./busd-pairs/RAMP-BUSD.svg": 1261,
	"./busd-pairs/SWAMP-BUSD.svg": 1262,
	"./busd-pairs/TPT-BUSD.svg": 1263,
	"./busd-pairs/TRX-BUSD.svg": 1264,
	"./busd-pairs/TUSD-BUSD.svg": 1265,
	"./busd-pairs/TXL-BUSD.svg": 1266,
	"./busd-pairs/UBXT-BUSD.svg": 1267,
	"./busd-pairs/USDC-BUSD.svg": 1268,
	"./busd-pairs/USDT-BUSD.png": 1269,
	"./busd-pairs/USDT-BUSD.svg": 1270,
	"./busd-pairs/UST-BUSD.svg": 1271,
	"./busd-pairs/VAI-BUSD.svg": 1272,
	"./busd-pairs/WELL-BUSD.svg": 1273,
	"./busd-pairs/WMASS-BUSD.svg": 1274,
	"./busd-pairs/XMARK-BUSD.svg": 1275,
	"./cake-pairs/BROOBEE-CAKE.svg": 1276,
	"./cake-pairs/CAKE-BUSD.svg": 1277,
	"./cake-pairs/NAR-CAKE.svg": 1278,
	"./cake-pairs/NYA-CAKE.svg": 1279,
	"./cake-pairs/STAX-CAKE.svg": 1280,
	"./cake-pairs/chr-busd.svg": 1281,
	"./cake-pairs/deri-busd.svg": 1282,
	"./cake-pairs/hotcross-bnb.svg": 1283,
	"./cake-pairs/rfox-bnb.svg": 1284,
	"./crow/crow.png": 1285,
	"./degens/ADA-BNB.svg": 1286,
	"./degens/BANANA-DOT-BNB.svg": 1287,
	"./degens/BANANA-SUSHI-BNB.svg": 1288,
	"./degens/BANANA-XRP-BNB.svg": 1289,
	"./degens/BANANA.svg": 1290,
	"./degens/BGO.png": 1291,
	"./degens/BIFI-BNB-banana.svg": 1292,
	"./degens/BIFI-BNB.svg": 1293,
	"./degens/BITI.png": 1294,
	"./degens/BLZD-BNB.png": 1295,
	"./degens/BLZD-BUSD.png": 1296,
	"./degens/BLZD.png": 1297,
	"./degens/DND.png": 1298,
	"./degens/FTS-BNB.svg": 1299,
	"./degens/FUEL-BNB.svg": 1300,
	"./degens/GOAL-BUSD.png": 1301,
	"./degens/IRON.png": 1302,
	"./degens/LINK-BNB.svg": 1303,
	"./degens/NAUT.png": 1304,
	"./degens/PALM.png": 1305,
	"./degens/SAT-BNB.png": 1306,
	"./degens/SAT-BUSD.png": 1307,
	"./degens/SBGO.png": 1308,
	"./degens/SOUP-BNB.svg": 1309,
	"./degens/SOUPS-BNB.svg": 1310,
	"./degens/SPACE-BNB.png": 1311,
	"./degens/SPACE-BUSD.png": 1312,
	"./degens/STEEL.png": 1313,
	"./degens/WINGS-BNB-BUSD.svg": 1314,
	"./degens/WINGS-BNB.svg": 1315,
	"./degens/WINGS-BUSD.svg": 1316,
	"./degens/WINGS-USDC-BUSD.svg": 1317,
	"./degens/WINGS.svg": 1318,
	"./degens/ZEFI-BNB.svg": 1319,
	"./degens/ZEFI-BUSD.svg": 1320,
	"./degens/ape-bnb.png": 1321,
	"./degens/banana-bnb.svg": 1322,
	"./degens/banana-busd.svg": 1323,
	"./degens/banana-ltc-bnb.svg": 1324,
	"./degens/brew-bnb.svg": 1325,
	"./degens/brew-busd.svg": 1326,
	"./degens/garuda-bnb.png": 1327,
	"./degens/garuda-usdc.png": 1328,
	"./degens/garuda-usdt.png": 1329,
	"./degens/grand-bnb.png": 1330,
	"./degens/grand.png": 1331,
	"./degens/mash-bnb.png": 1332,
	"./degens/mash-busd.png": 1333,
	"./degens/mash.png": 1334,
	"./degens/mfrm-bnb.png": 1335,
	"./degens/palm-bnb.png": 1336,
	"./degens/palm-busd.png": 1337,
	"./degens/panther-bnb.png": 1338,
	"./degens/panther-busd.png": 1339,
	"./degens/ramen-bnb.svg": 1340,
	"./degens/ramen-busd.svg": 1341,
	"./degens/salt-bnb.png": 1342,
	"./degens/salt-busd.png": 1343,
	"./degens/sdump-bnb.png": 1344,
	"./degens/sdump-busd.png": 1345,
	"./degens/slime-bnb.png": 1346,
	"./degens/slime-busd.png": 1347,
	"./degens/tndr-bnb.png": 1348,
	"./degens/tndr-busd.png": 1349,
	"./degens/tofy-bnb.png": 1350,
	"./degens/tofy-mash.png": 1351,
	"./degens/tofy.png": 1352,
	"./eth-pairs/ADA-ETH.svg": 1353,
	"./eth-pairs/BETH-ETH.svg": 1354,
	"./eth-pairs/BTCB-ETH.svg": 1355,
	"./eth-pairs/eth-usdc.svg": 1356,
	"./fantom/AAVE-FTM.png": 1357,
	"./fantom/ANY-FTM.png": 1358,
	"./fantom/BADGER-FTM.png": 1359,
	"./fantom/BAND-FTM.png": 1360,
	"./fantom/BIFI-FTM.png": 1361,
	"./fantom/BNB-FTM.png": 1362,
	"./fantom/BOO-FTM.png": 1363,
	"./fantom/BOO.png": 1364,
	"./fantom/BTC-FTM.png": 1365,
	"./fantom/COVER-FTM.png": 1366,
	"./fantom/CREAM-FTM.png": 1367,
	"./fantom/CRV-FTM.png": 1368,
	"./fantom/DAI-FTM.png": 1369,
	"./fantom/EST-FTM.png": 1370,
	"./fantom/EST.png": 1371,
	"./fantom/ETH-FTM.png": 1372,
	"./fantom/FROYO-3Pool.png": 1373,
	"./fantom/FROYO.png": 1374,
	"./fantom/ICE-FTM.png": 1375,
	"./fantom/LINK-FTM.png": 1376,
	"./fantom/SNX-FTM.png": 1377,
	"./fantom/SUSHI-FTM.png": 1378,
	"./fantom/USDC-FTM.png": 1379,
	"./fantom/USDT-FTM.png": 1380,
	"./fantom/WOOFY-FTM.png": 1381,
	"./fantom/YFI-FTM.png": 1382,
	"./heco/AAVE-USDT.svg": 1383,
	"./heco/BAL-USDT.svg": 1384,
	"./heco/ETH-USDT.png": 1385,
	"./heco/ETH-WHT.svg": 1386,
	"./heco/HBCH-USDT.svg": 1387,
	"./heco/HBTC-USDT.png": 1388,
	"./heco/HBTC-WHT.svg": 1389,
	"./heco/HDOT-USDT.svg": 1390,
	"./heco/HFI-HT.png": 1391,
	"./heco/HFI-HUSD.png": 1392,
	"./heco/HFIL-USDT.svg": 1393,
	"./heco/HLTC-USDT.svg": 1394,
	"./heco/HPT-USDT.svg": 1395,
	"./heco/HUSD-USDT.svg": 1396,
	"./heco/HUSD.png": 1397,
	"./heco/LAVA-HT.svg": 1398,
	"./heco/LAVA-USDT.svg": 1399,
	"./heco/LAVA.png": 1400,
	"./heco/LHB-USDT.svg": 1401,
	"./heco/LHB-WHT.png": 1402,
	"./heco/LINK-USDT.svg": 1403,
	"./heco/MDX-USDT.png": 1404,
	"./heco/MDX-WHT.png": 1405,
	"./heco/SNX-USDT.svg": 1406,
	"./heco/UNI-USDT.svg": 1407,
	"./heco/WHT-HUSD.png": 1408,
	"./heco/WHT-USDT.png": 1409,
	"./heco/YFI-USDT.svg": 1410,
	"./heco/fHT.png": 1411,
	"./heco/fUNI.png": 1412,
	"./kebab/ETH-BTCB.png": 1413,
	"./kebab/KEBAB-BTCB.png": 1414,
	"./kebab/USDT-BUSD.png": 1415,
	"./kite/KITE-BNB.png": 1416,
	"./kite/KITE-BUSD.png": 1417,
	"./kite/KITE.png": 1418,
	"./polygon/AAVE-ETH.png": 1419,
	"./polygon/ADDY.png": 1420,
	"./polygon/ANY-QUICK.png": 1421,
	"./polygon/AZUKI-ETH.png": 1422,
	"./polygon/BIFI-ETH.png": 1423,
	"./polygon/BIFI-MUST.png": 1424,
	"./polygon/BIFI-QUICK.png": 1425,
	"./polygon/BTC-USDC.png": 1426,
	"./polygon/CC10-ETH.png": 1427,
	"./polygon/CC10-QUICK.png": 1428,
	"./polygon/CEL-ETH.png": 1429,
	"./polygon/CRV-ETH.png": 1430,
	"./polygon/CURVE-3Pool.png": 1431,
	"./polygon/DEFI5-ETH.png": 1432,
	"./polygon/DEFI5-QUICK.png": 1433,
	"./polygon/DEGEN-ETH.png": 1434,
	"./polygon/DEGEN-QUICK.png": 1435,
	"./polygon/DOKI-ETH.png": 1436,
	"./polygon/ETH-BTC.png": 1437,
	"./polygon/ETH-DAI.png": 1438,
	"./polygon/ETH-MATIC.png": 1439,
	"./polygon/ETH-USDT.png": 1440,
	"./polygon/FISH-MATIC.svg": 1441,
	"./polygon/FRAX-FXS.png": 1442,
	"./polygon/FRAX-QUICK.png": 1443,
	"./polygon/FRAX-USDC.png": 1444,
	"./polygon/GRT-ETH.png": 1445,
	"./polygon/IRON-USDC.png": 1446,
	"./polygon/IRON.png": 1447,
	"./polygon/KRILL-USDC.png": 1448,
	"./polygon/LINK-ETH.png": 1449,
	"./polygon/MATIC-USDC.png": 1450,
	"./polygon/MATIC-WOOFY.png": 1451,
	"./polygon/MUST-ETH.png": 1452,
	"./polygon/MUST-MATIC.png": 1453,
	"./polygon/PZAP-MATIC.png": 1454,
	"./polygon/PZAP-USDC.png": 1455,
	"./polygon/QUICK-ETH.png": 1456,
	"./polygon/QUICK-MATIC.png": 1457,
	"./polygon/SNX-ETH.png": 1458,
	"./polygon/TITAN-ETH.png": 1459,
	"./polygon/TITAN-IRON.png": 1460,
	"./polygon/TITAN.png": 1461,
	"./polygon/UBT-ETH.png": 1462,
	"./polygon/USDC-DAI.png": 1463,
	"./polygon/USDC-ETH.png": 1464,
	"./polygon/USDC-MUST.png": 1465,
	"./polygon/USDC-USDT.png": 1466,
	"./polygon/VISION-ETH.png": 1467,
	"./polygon/VISION-QUICK.png": 1468,
	"./polygon/WISE-ETH.png": 1469,
	"./polygon/mOCEAN-MATIC.png": 1470,
	"./polygon/maUSDC-USDC.png": 1471,
	"./polygon/renDOGE-ETH.png": 1472,
	"./single-assets/AAVE.svg": 1473,
	"./single-assets/ADA.svg": 1474,
	"./single-assets/ATOM.png": 458,
	"./single-assets/AVAX.png": 459,
	"./single-assets/BAKE.png": 460,
	"./single-assets/BCH.svg": 1475,
	"./single-assets/BDO.png": 461,
	"./single-assets/BETH.png": 462,
	"./single-assets/BHC.png": 463,
	"./single-assets/BIFI.png": 464,
	"./single-assets/BIFI.svg": 1476,
	"./single-assets/BNB.png": 465,
	"./single-assets/BTCB.svg": 1477,
	"./single-assets/BTD.png": 466,
	"./single-assets/BTS.png": 467,
	"./single-assets/BUNNY.png": 468,
	"./single-assets/BURGER.png": 469,
	"./single-assets/BUSD.svg": 1478,
	"./single-assets/CAKE.png": 470,
	"./single-assets/CTK.png": 471,
	"./single-assets/DAI.svg": 1479,
	"./single-assets/DOT.png": 472,
	"./single-assets/DRUGS.png": 473,
	"./single-assets/ETH.png": 474,
	"./single-assets/FIL.svg": 1480,
	"./single-assets/FTM.png": 475,
	"./single-assets/HARD.png": 476,
	"./single-assets/HPS.png": 477,
	"./single-assets/HT.png": 478,
	"./single-assets/ICA.svg": 1481,
	"./single-assets/INCH.png": 479,
	"./single-assets/INJ.png": 480,
	"./single-assets/JETS.png": 481,
	"./single-assets/JULD.png": 482,
	"./single-assets/KEBAB.png": 483,
	"./single-assets/Kite.svg": 1482,
	"./single-assets/LINK.png": 484,
	"./single-assets/LTC.svg": 1483,
	"./single-assets/MATIC.png": 485,
	"./single-assets/MATIC.svg": 1484,
	"./single-assets/MDX.png": 486,
	"./single-assets/MSC.png": 487,
	"./single-assets/MSS.png": 488,
	"./single-assets/NUTS.png": 489,
	"./single-assets/NYA.png": 490,
	"./single-assets/NYAC.png": 491,
	"./single-assets/NYAS.png": 492,
	"./single-assets/PMP.svg": 1485,
	"./single-assets/POLYGON.png": 493,
	"./single-assets/SBDO.png": 494,
	"./single-assets/SFP.png": 495,
	"./single-assets/SMART.png": 496,
	"./single-assets/SOAK.png": 497,
	"./single-assets/SUSHI.png": 498,
	"./single-assets/SWAMP.svg": 1486,
	"./single-assets/SXP.svg": 1487,
	"./single-assets/TYPH.png": 499,
	"./single-assets/UNI.png": 500,
	"./single-assets/USDC.svg": 1488,
	"./single-assets/USDT.svg": 1489,
	"./single-assets/WBNB.svg": 1490,
	"./single-assets/XRP.svg": 1491,
	"./single-assets/XTZ.png": 501,
	"./single-assets/XVS.png": 502,
	"./single-assets/cakeHARD.png": 503,
	"./single-assets/cakeROOBEE.png": 504,
	"./single-assets/cakeSTAX.png": 505,
	"./single-assets/cakeTWT.png": 506,
	"./single-assets/cakebROOBEE.png": 507,
	"./single-assets/kite.png": 215,
	"./single-assets/sALPACA.svg": 1492,
	"./stake/apeswap/background.png": 1493,
	"./stake/apeswap/logo.png": 1494,
	"./stake/apyswap/background.png": 1495,
	"./stake/apyswap/logo.png": 1496,
	"./stake/astronaut/background.png": 1497,
	"./stake/astronaut/logo.png": 1498,
	"./stake/beefy/background.png": 1499,
	"./stake/beefy/beefyfinance.png": 1500,
	"./stake/billionhappiness/background.png": 1501,
	"./stake/billionhappiness/logo.png": 1502,
	"./stake/bingo/background.png": 1503,
	"./stake/bingo/logo.png": 1504,
	"./stake/biticity/background.png": 1505,
	"./stake/biticity/logo.png": 1506,
	"./stake/boost.svg": 217,
	"./stake/cafeswap/background.png": 1507,
	"./stake/cafeswap/brew.png": 1508,
	"./stake/cafeswap/cafeswap.png": 1509,
	"./stake/crowfinance/background.png": 1510,
	"./stake/crowfinance/crow.png": 1511,
	"./stake/crowfinance/crowfinance.png": 1512,
	"./stake/dopple/background.png": 1513,
	"./stake/dopple/logo.png": 1514,
	"./stake/dumpling/background.png": 1515,
	"./stake/dumpling/logo.png": 1516,
	"./stake/esterfinance/background.png": 1517,
	"./stake/esterfinance/logo.png": 1518,
	"./stake/f1.png": 508,
	"./stake/fanatics/logo.png": 1519,
	"./stake/fire.png": 299,
	"./stake/garuda/logo.png": 1520,
	"./stake/grandbanks/background.png": 1521,
	"./stake/grandbanks/logo.png": 1522,
	"./stake/icarus/background.png": 1523,
	"./stake/icarus/logo.png": 1524,
	"./stake/ironfinance/background.png": 1525,
	"./stake/ironfinance/logo.png": 1526,
	"./stake/jetswap/background.png": 1527,
	"./stake/jetswap/logo.png": 1528,
	"./stake/launchpool.png": 509,
	"./stake/mash/background.png": 1529,
	"./stake/mash/logo.png": 1530,
	"./stake/memefarm/ape.png": 1531,
	"./stake/memefarm/background.png": 1532,
	"./stake/memefarm/logo.png": 1533,
	"./stake/panther/background.png": 1534,
	"./stake/panther/logo.png": 1535,
	"./stake/polygon/background.png": 1536,
	"./stake/polygon/logo.png": 1537,
	"./stake/ramenswap/background.png": 1538,
	"./stake/ramenswap/ramen.png": 1539,
	"./stake/ramenswap/ramenswap.png": 1540,
	"./stake/safefarm/background.png": 1541,
	"./stake/safefarm/logo.png": 1542,
	"./stake/saltswap/background.png": 1543,
	"./stake/saltswap/salt.png": 1544,
	"./stake/saltswap/saltswap.png": 1545,
	"./stake/satis/background.png": 1546,
	"./stake/satis/logo.png": 1547,
	"./stake/slimefinance/background.png": 1548,
	"./stake/slimefinance/logo.png": 1549,
	"./stake/slimefinance/slime.png": 1550,
	"./stake/soup/background.png": 1551,
	"./stake/soup/logo.png": 1552,
	"./stake/space/background.png": 1553,
	"./stake/space/logo.png": 1554,
	"./stake/squirrel/background.png": 1555,
	"./stake/squirrel/logo.png": 1556,
	"./stake/squirrel/nuts.png": 1557,
	"./stake/swirl/background.png": 1558,
	"./stake/swirl/logo.png": 1559,
	"./stake/thunder/background.png": 1560,
	"./stake/thunder/logo.png": 1561,
	"./stake/thypoon/background.png": 1562,
	"./stake/thypoon/logo.png": 1563,
	"./stake/xbtc/background.png": 1564,
	"./stake/xbtc/logo.png": 1565,
	"./stake/yieldbay/background.png": 1566,
	"./stake/yieldbay/logo.png": 1567,
	"./stake/zcore/background.png": 1568,
	"./stake/zcore/logo.png": 1569,
	"./uncategorized/BADGER-BTCB.svg": 1570,
	"./uncategorized/BAT-BAKE.svg": 1571,
	"./uncategorized/BDIGG-BTCB.svg": 1572,
	"./uncategorized/BELT-VENUSBLP.png": 1573,
	"./uncategorized/BETH-ETH.svg": 1574,
	"./uncategorized/COMP-ETH.svg": 1575,
	"./uncategorized/DOPPLE-DOLLY-LP.svg": 1576,
	"./uncategorized/DOPPLE-DOP-LP.svg": 1577,
	"./uncategorized/DOPPLE-UST-LP.png": 1578,
	"./uncategorized/EPS-FUSDT.png": 1579,
	"./uncategorized/EPS.png": 1580,
	"./uncategorized/EPS3.png": 1581,
	"./uncategorized/ETH-USDT.png": 1582,
	"./uncategorized/PNT-PBTC.svg": 1583,
	"./uncategorized/SUSHI-ETH.svg": 1584,
	"./uncategorized/TBTC-BTCB.svg": 1585,
	"./uncategorized/THUGS-NAR.png": 1586,
	"./uncategorized/bTRI-CRED.png": 1587,
	"./uncategorized/renBTC-BTC.png": 1588,
	"./usdt-pairs/BIFI-USDT.png": 1589,
	"./usdt-pairs/BNB-USDT.png": 1590,
	"./usdt-pairs/BTCB-USDT.svg": 1591,
	"./usdt-pairs/ETH-USDT.svg": 1592,
	"./usdt-pairs/FIL-USDT.png": 1593,
	"./usdt-pairs/LHB-USDT.png": 1594,
	"./usdt-pairs/LYD-USDT.png": 1595,
	"./usdt-pairs/SHIB-USDT.png": 1596,
	"./usdt-pairs/USDT-USDC.png": 1597,
	"./ust-pairs/MAMZN-UST.svg": 1598,
	"./ust-pairs/MCOIN-UST.svg": 1599,
	"./ust-pairs/MGOOGL-UST.svg": 1600,
	"./ust-pairs/MIR-UST.svg": 1601,
	"./ust-pairs/MNFLX-UST.svg": 1602,
	"./ust-pairs/MTSLA-UST.svg": 1603,
	"./wallets/binance-wallet.png": 438,
	"./wallets/math-wallet.svg": 295,
	"./wallets/metamask.png": 1604,
	"./wallets/metamask.svg": 1605,
	"./wallets/safepal-wallet.svg": 440,
	"./wallets/trust-wallet.svg": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;